// AuthLogoutHandler.js
// Provides a logout cleanup helper that clears auth state without causing an immediate redirect.

export const performLogoutNoRedirect = () => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error("AuthLogoutHandler: failed to clear localStorage", error);
  }

  // Notify any listeners about logout so they can update UI state.
  window.dispatchEvent(new Event("logout"));
  window.dispatchEvent(new Event("authStateChanged"));
};
